// extracted by mini-css-extract-plugin
module.exports = {"heading":"idt-addgroupbuttonmobile_heading__14spe","icon":"idt-addgroupbuttonmobile_icon__2ngyn"};